import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Usuario } from './usuarios.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class UsuarioService {

  private usuariosURL: string = urlJoin(environment.apiURL, 'usuarios')

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getUsuarios(params?: string ): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(this.usuariosURL+'?'+params)
    //return this.http.get<Usuario[]>(this.usuariosURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getUsuario(id: string): Observable<any> {
    const getUsuarioURL = urlJoin(this.usuariosURL, id)
    return this.http.get<Usuario>(getUsuarioURL)
      .pipe(
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateUsuario(id: string, usuario: Usuario): Observable<any> {
    const updateUsuarioURL = urlJoin(this.usuariosURL, id)
    return this.http.put<Usuario>(updateUsuarioURL, usuario)
      .pipe(
        tap(() => {
          const updateUsuarioSuccessMessage: string = $localize`:@@updateUsuarioSuccessMessage:Usuario modificado correctamente`;
          this.notificationsService.showSuccessNotification(updateUsuarioSuccessMessage)
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  deleteUsuario(id: string): Observable<any> {
    const deleteUsuarioURL = urlJoin(this.usuariosURL, id)
    return this.http.delete<Usuario>(deleteUsuarioURL)
      .pipe(
        tap(() => {
          //this.toastr.success('Profesional borrado correctamente');
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateUsuarioEstado(id: string, accion: 'ACTIVAR' | 'DESACTIVAR'): Observable<any> {
    const updateUsuarioEstadoURL = urlJoin(this.usuariosURL, id, 'estado');
    return this.http.put<Usuario>(updateUsuarioEstadoURL, { accion })
      .pipe(
        tap(() => { }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newUsuario(usuario: Usuario): Observable<any> {
    const newUsuarioURL = urlJoin(this.usuariosURL, "registro/usuario")
    return this.http.post<Usuario>(newUsuarioURL, usuario)
      .pipe(
        tap(() => {
          const newUsuarioSuccessMessage: string = $localize`:@@newUsuarioSuccessMessage:Usuario creado correctamente`;
          this.notificationsService.showSuccessNotification(newUsuarioSuccessMessage)
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateAvatar(id: string, avatar: FormData): Observable<any> {
    const updateAvatarURL = urlJoin(this.usuariosURL, id, "/foto");
    return this.http.put<Usuario>(updateAvatarURL, avatar)
      .pipe(
        tap(() => { }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }

  getAvatar(id: string): Observable<any> {
    const getAvatarURL = urlJoin(this.usuariosURL, id, "/descargarFoto");
    return this.http.get(getAvatarURL, { responseType: 'blob' }) // Aquí está el cambio clave
      .pipe(
        tap(() => { }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }

}
